const route = {
    getlist: 'route/getlist',
    add: 'route/add',
    update: 'route/update',
    remove: 'route/remove',
    get: 'route/get',
    getall: 'route/getall',
    clearcache: 'route/clear-cache',
}
export default route
